import styled from '@emotion/styled';
import { Theme as MaterialUITheme } from '@mui/material/styles';
import PriorityNumber from '../../Tasks/PriorityNumber';
import PolarisIcon from '../PolarisIcon';
import ConditionalTooltip from '../ConditionalTooltip/ConditionalTooltip';

type TableDragHandleProps = {
  priority: number;
  isDraggable: boolean;
};

const TableDragHandle = ({ priority, isDraggable }: TableDragHandleProps) => {
  return (
    <ConditionalTooltip title="Cannot assign priority to completed tasks" show={!isDraggable}>
      <DragHandle priority={priority > 0} draggable={isDraggable}>
        {priority > 0 && <StyledPriorityNumber priority={priority} />}
        {isDraggable && <DragHandleIcon id="drag-handle" icon="grip" height={20} />}
        {!isDraggable && !priority && <MinusIcon icon="empty" height={10} />}
      </DragHandle>
    </ConditionalTooltip>
  );
};

export default TableDragHandle;

const DragHandleIcon = styled(PolarisIcon)`
  opacity: 0.5;
  min-width: 35px;
  color: ${({ theme }) => theme.palette.text.primary};

  &:hover {
    cursor: grab;
  }
`;

const MinusIcon = styled(PolarisIcon)`
  margin-left: 13px;
`;

const StyledPriorityNumber = styled(PriorityNumber)`
  position: absolute;
`;

const DragHandle = styled.div<{ priority: boolean; draggable: boolean; }>`
  position: relative;
  width: 35px;
  transition: all 200ms ease-in-out;
  pointer-events: ${({ draggable }) => (draggable ? 'inherit' : 'none')};

  > svg:first-of-type {
    display: ${({ priority }) => (priority ? 'none' : 'inherit')};
  }

  &:hover {
    > div:first-of-type {
      display: none;
    }

    > svg:first-of-type {
      display: inherit;
      color: ${({ theme }) => (theme as MaterialUITheme).palette.primary.main}; // theme's type is getting overwritten by draggableProps
    }
  }
`;
